<template>
    <div>
        <feedback-review
            v-if="currentStep('feedback')"
            :image="image"
            :text="feedbackText"
            :form="form"
            :rating="true"
            @submit="fromFeedback"
            :textSubmit="submitBtnFeedback"
            :textBack="backBtnFeedback"
            @back="backFromFeedback"
        />

        <share
            v-if="currentStep('share')"
            :image="image"
            :sites="invite.review_sites"
            :question="shareMessage"
            :locationName="invite.location.name"
            :allowPrivateFeedback="campaign.allow_private_feedback"
            @feedback="askFeedbackFromShare"
            @site="openSite"
        />

        <thank-you
            v-if="currentStep('thank_you')"
            :image="image"
            :text="thankYouMessage"
        />
    </div>
</template>

<script>
export default {
    props: {
        invite: { required: true, type: Object },
        review: { required: true, type: Object },
        image: { required: true, type: String },
        settings: { type: Object },
        googleApiEnabled: { type: Boolean },
        initialStep: { default: null },
    },

    data() {
        return {
            form: this.setupForm(this.review),
            step: this.initialStep || 'share',
            feedback_from_share: false,
        };
    },

    computed: {
        shareMessage() { return this.settings.share_message || 'Where would you like to leave your review?'; },
        thankYouMessage() { return this.settings.thank_you_message || 'Thank you!'; },
        feedbackText() { return this.settings.feedback_message || 'Please tell us more about your experience'; },
        submitBtnFeedback() { return this.settings.submit_button_feedback || 'Submit'; },
        backBtnFeedback() { return this.settings.back_button_feedback || 'Back'; },

        campaign() {
            return this.invite.campaign;
        },
        positive_threshold() {
            return this.form.rating > this.campaign.threshold;
        },
        sharable() {
            return this.campaign.redirect_to_review_site && this.positive_threshold;
        },
        ask_for_feedback() {
            return this.campaign.ask_for_feedback;
        },
        ask_for_recommend() {
            return this.campaign.ask_for_recommend;
        },
    },

    methods: {
        save() {
            if (this.form.id) {
                return this.form
                    .put(this.$laroute.route('api.reviews.update', { review: this.form.id }))
                    .then(({ data }) => (this.form = this.setupForm(data.data)));
            }

            return this.form
                .post(this.$laroute.route('api.reviews.store', { token: this.form.invite.token }))
                .then(({ data }) => (this.form = this.setupForm(data.data)));
        },

        setupForm(review = {}) {
            return new Form({
                ...review,
                type: this.invite.campaign.type,
            });
        },

        fromRecommend(yes) {
            this.save()
                .then(() => {
                    this.step = 'share';
                    if (!yes || this.invite.review_sites.length === 0) {
                        this.step = 'feedback';
                    }
                })
                .catch(this.onError.bind(this));
        },

        backFromFeedback() {
            this.step = 'share';
        },

        backFromShare() {
            this.step = 'share';
        },

        fromFeedback() {
            if (this.form.rating == null) {
                let error = {data: { message: 'The rating is required.' } };
                return this.onError(error);
            }

            this.save()
                .then(() => {
                    this.step = 'thank_you';
                    if (this.sharable && !this.feedback_from_share) {
                        this.step = 'share';
                    }
                })
                .catch(this.onError.bind(this));
        },

        askFeedbackFromShare() {
            this.feedback_from_share = true;
            this.step = 'feedback';
            if (this.ask_for_feedback) {
                this.step = 'thank_you';
            }
        },

        openSite(review_site) {
            if (this.googleApiEnabled && review_site.site === 'google') {
                this.createReview();
                return;
            }

            window.location.href = review_site.url;
        },

        currentStep(step) {
            return this.step === step;
        },

        onError(error) {
            if (error.status !== 422) {
                this.$alert({ type: 'error', message: error.data.message || 'Unknown error' });
            }
        },

        createReview() {
            let placeId = this.invite.location.write_review_google_url;

            var googlePublishReviewFlow = google.places.reviews.createPublishReviewFlow({
                placeId: placeId,
                enableStandaloneFlow: true
            });

            googlePublishReviewFlow.addListener('complete', function() {
                console.log('publish completed')
            });

            googlePublishReviewFlow.addListener('publish', function() {
                console.log('review published successfully')
            });

            googlePublishReviewFlow.addListener('error', function() {
                console.log("uh oh. something didn't work")
            });
        }
    },
};
</script>
